import RestaurantBanner, { RestaurantBannerProps } from './RestaurantBanner';
import withInteractor from './RestaurantBanner.interactor';
import withPresenter from './RestaurantBanner.presenter';
  
export type { RestaurantBannerProps };
export default withInteractor(withPresenter(RestaurantBanner));


